import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { ICategory } from "../shared/models/categories.model";
import { ClientData } from "./client";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class CategoriesData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private tracking: TrackingProvider,
    private clientData: ClientData,
  ) { }

  public getCategoriesByClient(client: string): Observable<ICategory[]> {
    return this.afDb.list<ICategory>(`ClientConfig/${client}/categories`).
      valueChanges();
  }

  public createCategory(client: string, category: ICategory) {
    if (!category.id) {
      this.action = "create";
      category.id = this.afDb.createPushId();
    } else {
      this.action = "update";
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`ClientConfig/${client}/categories/${category.id}`)
        .update(category)
        .then(() => {
          return this.historyData.set(
            `Category content`,
            "categories",
            this.action,
            category,
          );
        })
        .then(() => {
          this.clientData.getClientConfig(client).once("value").then((dataInfo) => {
            this.tracking.trackEntity(_TRACKING_ENTITIES.client, client, client, null, dataInfo, "Tracking cuando se actualizan las categorias");
          });
          resolve(category);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getClientCategoriesById(clientId: string, categoryId: string): Observable<ICategory> {
    return this.afDb.object<ICategory>(`ClientConfig/${clientId}/categories/${categoryId}`).valueChanges();
  }

}
 // end file



// WEBPACK FOOTER //
// ./src/providers/categories.ts